import { NavLink } from "react-router-dom";
import styles from "./cta-insight.module.css";

interface IProps {
  subTitle: string;
  title: string;
  servicoText?: string;
  onHandlePages: any;
  id?: string;
}

const CTAinsightComponent = ({
  subTitle,
  title,
  servicoText,
  onHandlePages,
  id,
}: IProps) => {
  return (
    <div className={styles.shape}>
      <div className={styles.div_texts}>
        <span className={styles.subtitle_cta}>{subTitle}</span>
        <h2 className={styles.title_cta}>{title}</h2>
        <p className={styles.paragraph_cta}>{`${servicoText?.substring(
          0,
          35
        )}...`}</p>
      </div>
      <NavLink
        to={`/insights/post/${id}`}
        onClick={() => onHandlePages("INSIGHTS")}
      >
        <button className={styles.btn_saibaMais}>LER MAIS</button>
      </NavLink>
    </div>
  );
};

export default CTAinsightComponent;
